import * as types from "./ActionTypes";
import Helper from "../functions/Helper.js";

//function for Quiz

export function changeQuestion(value) {
  return {
    type: types.CHANGE_QUESTION,
    value: value,
  };
}
export function collapseAllFilters(value) {
  return {
    type: types.COLLAPSALLFILTER,
    value: value,
  };
}
export function quizFilter(value) {
  return {
    type: types.QUIZ_FILTER,
    value: value,
  };
}

export function changeAnswer(value) {
  return {
    type: types.CHANGE_ANSWER,
    value: value,
  };
}

export function initiateQuestions(value) {
  return {
    type: types.INITIATE_QUESTIONS,
    value: value,
  };
}

export function quizNewCount(value) {
  return {
    type: types.NEW_COUNT,
    value: value,
  };
}

export function quizOutputData(value) {
  return {
    type: types.QUIZ_OUTPUTDATA,
    value: value,
  };
}

export function editing() {
  return {
    type: types.EDITING,
  };
}
export function changePage(value) {
  return {
    type: types.PAGINATION,
    value: value,
  };
}

export function addFav(value) {
  return {
    type: types.ADDFAV,
    value: value,
  };
}

export function removeFav(value) {
  return {
    type: types.REMOVEFAV,
    value: value,
  };
}

export function add_like(value) {
  return {
    type: types.ADD_LIKE,
    value: value,
  };
}

export function delete_like(value) {
  return {
    type: types.DELETE_LIKE,
    value: value,
  };
}

export function no_ssr() {
  return {
    type: types.NOSSR,
  };
}

export function setExperiment(value) {
  return {
    type: types.EXPERIMENT,
    value: value,
  };
}

export function shoeData(value) {
  return {
    type: types.SHOEDATA,
    value: value,
  };
}

export function expand(value) {
  return {
    type: types.EXPAND,
    value: value,
  };
}

export function set_overview(value) {
  return {
    type: types.OVERVIEW,
    value: value,
  };
}

export function initial_data(value) {
  return {
    type: types.INITIALDATA,
    value: value,
  };
}

export function update_data(value) {
  return {
    type: types.UPDATEDATA,
    value: value,
  };
}

export function searchtext(value) {
  return {
    type: types.SEARCHTEXT,
    value: value,
  };
}

export function switchValue(value) {
  return {
    type: types.SWITCH,
    value: value,
  };
}

export function last_visit() {
  return {
    type: types.LASTVISIT,
  };
}

export function collapse_filter(value) {
  return {
    type: types.COLLAPSFILTER,
    value: value,
  };
}

export function setFilterStyle(value) {
  return {
    type: types.SETFILTERSTYLE,
    value: value,
  };
}

export function fetchedAdditionalData(value) {
  return {
    type: types.FETCHEDADDITIONALDATA,
    value: value,
  };
}

export function updateLikeCounter(shoe_id, style_id, addition) {
  return {
    type: types.UPDATELIKECOUNTER,
    value: { shoe_id, style_id, addition },
  };
}

export function setSortStylesBy(value) {
  return {
    type: types.SETSORTESTYLESBY,
    value: value,
  };
}

export function start_filtering() {
  return {
    type: types.FILTERING,
  };
}

export function abort_function(value) {
  return {
    type: types.ABORTFUNCTION,
    value: value,
  };
}

export function filterObject(value) {
  return {
    type: types.FILTEROBJECT,
    value: value,
  };
}

export function urlMapping(value) {
  return {
    type: types.URLMAPPING,
    value: value,
  };
}

export function menu(value) {
  return {
    type: types.MENU,
    value: value,
  };
}

export function login(value) {
  return {
    type: types.LOGIN,
    value: value,
  };
}

export function logout() {
  return {
    type: types.LOGOUT,
  };
}

export function visitedQuiz() {
  return {
    type: types.VISITEDQUIZ,
  };
}

export function getNotifications(value) {
  return (dispatch) => {
    return fetch(__server__ + "/API/pub/notifications", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        dispatch({ type: types.NOTIFICATIONS, value: data });
      });
  };
}

export function addLike(style_id, shoe_id) {
  return function (dispatch, getState) {
    const { persistData } = getState();
    const likes = persistData.likes;

    let alreadyLiked =
      likes.filter((like) => like.style_id === style_id).length > 0;
    if (!alreadyLiked) {
      let placeholderLike = {
        secret: Helper.randomString(16),
        style_id: style_id,
        date: Date.now(),
        source: "web",
      };
      dispatch(add_like(placeholderLike));
      //dispatch(updateLikeCounter(shoe_id,style_id,1))

      return fetch(__server__ + "/API/pub/like", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(placeholderLike),
      })
        .then((response) => response.json())
        .then((data) => {
          if (!data.error) {
            //console.log("added like successfully")
            //firebase.analytics().logEvent("addLike",{success:true});
          } else {
            //console.log("error when ADDING like")
            //firebase.analytics().logEvent("addLike",{success:false});
          }
        })
        .catch((error) => {
          //eslint-disable-line
          //console.log("error when ADDING like")
          //firebase.analytics().logEvent("addLike",{success:false});
        });
    }
  };
}

export function deleteLike(style_id, shoe_id) {
  return function (dispatch, getState) {
    let { persistData } = getState();
    let like = persistData.likes.filter((like) => like.style_id == style_id)[0];
    dispatch(delete_like(style_id));
    //dispatch(updateLikeCounter(shoe_id,style_id,-1))
    if (like != undefined) {
      return fetch(__server__ + "/API/pub/like", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...like }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success === "success") {
            //console.log("removed like successfully")
            //firebase.analytics().logEvent("removeLike",{success:true});
          } else {
            //console.log("error when removing like")
            //firebase.analytics().logEvent("removeLike",{success:false});
          }
        })
        .catch((error) => {
          //eslint-disable-line
          //console.log("error when removing like")
          //firebase.analytics().logEvent("removeLike",{success:false});
        });
    }
  };
}

const fetchColorways = (shoe_id) => {
  return fetch(__server__ + "/API/pub/colorways/" + shoe_id, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
};

const fetchResells = (shoe_id) => {
  return fetch(__server__ + "/API/pub/resells/" + shoe_id, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
};

const fetchStyles = (shoe_id) => {
  return fetch(__server__ + "/API/pub/styles/" + shoe_id, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    });
};

const filterPromise = (queryString, controller) => {
  return fetch(__server__ + "/API/pub/filter" + queryString, {
    signal: controller.signal,
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((data) => ({ data: data, abortFunction: controller }))
    .catch((error) => {
      return "error";
    });
};

export function fetchFilters(queryString) {
  const controller = new AbortController();

  return (dispatch) => {
    dispatch(abort_function(() => controller.abort()));
    filterPromise(queryString, controller).then((data) => {
      if (data !== "error") {
        dispatch(update_data(data.data));
      }
    });
  };
}

export function fetch_colorways_and_styles(shoe_id) {
  return (dispatch) => {
    let waitForAllRequests = Promise.all([
      fetchColorways(shoe_id),
      fetchStyles(shoe_id),
      fetchResells(shoe_id),
    ]);
    return waitForAllRequests.then(([colorways, styles, resells]) => {
      styles.forEach((style) => {
        style.colorways = colorways.filter(
          (colorway) => colorway.style_id === style.style_id
        );
        style.resells = resells.filter(
          (resell) => resell.style_id === style.style_id
        );
      });
      dispatch(
        fetchedAdditionalData({
          payload: { styles: styles, colorways: colorways, resells: resells },
          shoe_id: shoe_id,
        })
      );
    });
  };
}

export function get_data(object) {
  if (object.hasOwnProperty("data")) {
    let shoes = object.data;

    let categories = [
      "rating",
      "traction",
      "cushion",
      "support",
      "materials",
      "fit",
      "outdoor",
    ];

    categories.forEach((category) => {
      shoes = Helper.ratingOrderBy(shoes, category, "desc");
      shoes = shoes.map((shoe, index) => ({
        ...shoe,
        ranking: { ...shoe.ranking, [category]: index + 1 },
      }));
    });

    shoes = Helper.ratingOrderBy(shoes, "release_date", "desc");
    return initial_data({ data: shoes });
  }
}
